module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAVNJREFUaEPtmDFuwkAQRWeM0nEBkOI6UkpOYhPalJwBmhCEhMQ1aBeci1BTgxuK5ASIZCIXoCggy7s7GFt8157Z+f/9tb1mqvnFNZ+fIODWBEEABDwdQIQ8DfQuvx8Cnf7q4fNrO2GSVxFpeVuX04CZd0I8bzae3tbmeZ+3VmECYWymJDS85uBnvTmYpUl3oCMgWqRE8limgIzENnlp6wiIzYGEGmUKyNZKP3q5KbGJEAS40NMk8E1CgcsQPjUQcHQvjA0IuEQJEUKEXHLzpwYROkUoWvwQSeE3t6fxp3I9AhDgxgQEsAfckoNNfOZbeIOnkO6RMjLimQb7ct1DfXkCrvNb5QKBgGm8SXrv9tbqVRT+NAj/CajC8JkNTgKqMryTgCoNby2gasPbCYiXozTpjvW2n06nwntAZzn9LhCg76ldRxCw80v/bhDQ99SuY+0J/AKUmaUx/o3fawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/basicInfo/ic_message@2x.png
// module id = kgIp
// module chunks = 3